import { api } from "./base";
/**
 * Голос вокалиста (батч 16, вариант А + ИИ-персона). ТОЛЬКО САЙТ: бэкенд отдаёт
 * 403 для этих ручек в miniApp, поэтому весь UI гейтится по платформе (не
 * miniApp) на фронте — см. `isAnyMiniApp()`.
 *
 * Две сущности голоса храним у себя (реестр Suno их не отдаёт):
 *  - CLONE  — реальный клон: пользователь ПОЁТ фразу (2 шага: запись голоса →
 *             валидация → Suno даёт фразу → запись пения фразы → верификация).
 *  - PERSONA — ИИ-голос из готового трака (проще: один POST /persona).
 *
 * Базовый путь: /api/v1/public/voice.
 *
 * Заголовки авторизации (Bearer / initData / X-Session-Id) навешивает
 * axios-интерсептор `api` — здесь их не дублируем (как в shares.ts).
 */
const VOICE_BASE = "/api/v1/public/voice";
/** Готов ли профиль к использованию в генерации (устойчиво к регистру). */
export const isVoiceProfileReady = (p) => p.is_ready || String(p.status).toLowerCase() === "ready";
/** Терминальная ошибка профиля (устойчиво к регистру). */
export const isVoiceProfileFailed = (p) => String(p.status).toLowerCase() === "failed";
/** Ждёт записи пения фразы (шаг 2 клона). */
export const isVoiceProfileAwaitingVerify = (p) => String(p.status).toLowerCase() === "awaiting_verify";
// Multipart-заголовок: снимаем Content-Type (undefined), чтобы браузер сам
// выставил boundary. Тот же приём, что в uploadSharePhoto (shares.ts).
const MULTIPART_HEADERS = { "Content-Type": undefined };
/**
 * Шаг 1 клона: отправить свободную запись голоса на валидацию. `vocalStartS` /
 * `vocalEndS` — секунды фрагмента (упрощённо — весь файл: 0..длительность).
 * Возвращает профиль со status=validating; дальше поллим getVoiceProfile до
 * awaiting_verify (появится `phrase`).
 */
export const validateClone = async (file, vocalStartS, vocalEndS, name, language) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("vocal_start_s", String(vocalStartS));
    formData.append("vocal_end_s", String(vocalEndS));
    if (name)
        formData.append("name", name);
    if (language)
        formData.append("language", language);
    const res = await api.post(`${VOICE_BASE}/clone/validate`, formData, { headers: MULTIPART_HEADERS });
    return res.data;
};
/** Профиль голоса по id (для поллинга статуса/получения `phrase`). */
export const getVoiceProfile = async (id) => {
    const res = await api.get(`${VOICE_BASE}/profiles/${id}`);
    return res.data;
};
/**
 * Шаг 2 клона: отправить запись пения показанной фразы. Профиль переходит в
 * processing; дальше поллим getVoiceProfile до ready (или failed).
 */
export const verifyClone = async (id, file, opts) => {
    const formData = new FormData();
    formData.append("file", file);
    if (opts?.voiceName)
        formData.append("voice_name", opts.voiceName);
    if (opts?.description)
        formData.append("description", opts.description);
    if (opts?.style)
        formData.append("style", opts.style);
    if (opts?.singerSkillLevel)
        formData.append("singer_skill_level", opts.singerSkillLevel);
    const res = await api.post(`${VOICE_BASE}/clone/${id}/verify`, formData, { headers: MULTIPART_HEADERS });
    return res.data;
};
/**
 * ИИ-голос из готового трака: один POST. Возвращает профиль kind=persona со
 * status=processing; дальше поллим getVoiceProfile до ready.
 */
export const createPersona = async (payload) => {
    const res = await api.post(`${VOICE_BASE}/persona`, payload);
    return res.data;
};
/** Список профилей голоса текущего юзера (CLONE + PERSONA, все статусы). */
export const listVoiceProfiles = async () => {
    const res = await api.get(`${VOICE_BASE}/profiles`);
    return res.data;
};
/** Удалить профиль голоса. */
export const deleteVoiceProfile = async (id) => {
    await api.delete(`${VOICE_BASE}/profiles/${id}`);
};
/** Переименовать профиль голоса. */
export const renameVoiceProfile = async (id, name) => {
    const res = await api.patch(`${VOICE_BASE}/profiles/${id}`, { name });
    return res.data;
};
